import { motion } from "framer-motion";

import Header from "../components/Header";
import Footer from "../components/Footer";
import Tag from "../components/Tag";
import WelcomeSection from "../components/sections/WelcomeSection";
import AboutSection from "../components/sections/AboutSection";
import HowSection from "../components/sections/HowSection";
import QuoteSection from "../components/sections/QuoteSection";
import SecondQuoteSection from "../components/sections/SecondQuoteSection";
import FeatureSection from "../components/sections/FeatureSection";
import AvailabilitySection from "../components/sections/AvailabilitySection";
import FAQSection from "../components/sections/FAQSection";

import "../styles/home.scss";
import CertificationSection from "../components/sections/CertificationSection";

function Home() {

    return (
        <>
            <Header />
            <motion.div
                className="page home min-height"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <div className="home-sections">
                    <WelcomeSection />
                    <AboutSection />
                    <AvailabilitySection />
                    <QuoteSection />
                    <HowSection />
                    <SecondQuoteSection />
                    <FeatureSection />
                    <FAQSection />
                </div>
            </motion.div>
            <Footer />
            <CertificationSection />
            <Tag />
        </>
    );
}

export default Home;

// https://www.youtube.com/watch?v=YOAeBSCkArA